<div class="duplicate-day-page-container">
  <mwo-breadcrumb (click)="back()" title="{{ 'planning.schedule' | translate }}"></mwo-breadcrumb>
  <mwo-duplicate-day></mwo-duplicate-day>
</div>
